"use strict";

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.TransitionLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _shouldNavigate = require("../utils/shouldNavigate");

var _triggerTransition = require("../utils/triggerTransition");

var _createTransitionContext = require("../context/createTransitionContext");

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/components/TransitionLink.js";

if (typeof _react.forwardRef === 'undefined') {
  _react.forwardRef = (function (C) {
    return C;
  }, function () {
    throw new Error('"' + "forwardRef" + '" is read-only.');
  }());
}

var TransitionLink = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var to = _ref.to,
      children = _ref.children,
      exit = _ref.exit,
      entry = _ref.entry,
      activeStyle = _ref.activeStyle,
      partiallyActive = _ref.partiallyActive,
      style = _ref.style,
      className = _ref.className,
      activeClassName = _ref.activeClassName,
      state = _ref.state,
      _onClick = _ref.onClick,
      trigger = _ref.trigger,
      replace = _ref.replace,
      innerRef = _ref.innerRef,
      preventScrollJump = _ref.preventScrollJump,
      rest = _objectWithoutProperties(_ref, ["to", "children", "exit", "entry", "activeStyle", "partiallyActive", "style", "className", "activeClassName", "state", "onClick", "trigger", "replace", "innerRef", "preventScrollJump"]);

  return /*#__PURE__*/_react.default.createElement(_createTransitionContext.Consumer, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 4
    }
  }, function (_ref2) {
    var disableAnimation = _ref2.disableAnimation,
        context = _objectWithoutProperties(_ref2, ["disableAnimation"]);

    return /*#__PURE__*/_react.default.createElement(_gatsby.Link, (0, _extends2.default)({
      style: style,
      activeStyle: activeStyle,
      className: className,
      activeClassName: activeClassName,
      partiallyActive: partiallyActive,
      onClick: function onClick(event) {
        // If the user has set their browser or OS to prefers-reduced-motion
        // we should respect that.
        if (disableAnimation) {
          return;
        }

        var weShouldNavigate = (0, _shouldNavigate.shouldNavigate)(event);

        if (weShouldNavigate) {
          (0, _triggerTransition.triggerTransition)(_objectSpread({
            event: event,
            to: to,
            exit: exit,
            entry: entry,
            trigger: trigger,
            replace: replace,
            preventScrollJump: preventScrollJump,
            linkState: state
          }, context));
        }

        if (typeof _onClick === 'function') {
          _onClick(event, weShouldNavigate);
        }
      },
      to: to // use gatsby link so prefetching still happens. this is prevent defaulted in triggertransition
      ,
      ref: ref || innerRef
    }, rest, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 6
      }
    }), children);
  });
});
exports.TransitionLink = TransitionLink;
TransitionLink.propTypes = {
  to: _propTypes.default.string.isRequired,
  exitLength: _propTypes.default.number,
  entryDelay: _propTypes.default.number,
  exitFn: _propTypes.default.func,
  entryState: _propTypes.default.object
};